import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
import translations from '@/translations'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.getters['localization/globalLocale'],
  messages: translations
})

const LocaleMixin = {
  computed: {
    locale () {
      return this.$store.getters['localization/globalLocale']
    }
  },

  watch: {
    locale () {
      this.$i18n.locale = this.locale
    }
  }
}

export { Vue, store, i18n, LocaleMixin }



// WEBPACK FOOTER //
// ./src/locale_watcher.js